const embedParams = readEmbedParams();

function readEmbedParams(): URLSearchParams {
  if (typeof window === "undefined") return new URLSearchParams();

  try {
    return new URLSearchParams(window.name);
  } catch (error) {
    console.error("Error parsing embed params from window.name:", error);
    return new URLSearchParams();
  }
}

export const getEmbedParam = (key: string): string | null =>
  embedParams.get(key);

export const isLoginEnabled = (): boolean =>
  embedParams.get("withLogin") !== "false";
